export const filterMapping = {
  filterName: "filterBeVariable",
  kategoriSurat: "kategoriSurat",
  kategoriPupuk: "category",
  //
  status: "statusFertilizer",
  poktan: "poktanId",
  jenisPupuk: "pertilizerTypeId",
  kategoriPengajuan: "katPengajuan",
  jenisTanaman: "plantId",
} as const;

export type FilterKey = keyof typeof filterMapping;

export type Option = { label: string; value: string };
